var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMwStudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6332 5.72927C11.8018 2.06327 16.474 0.737875 19.5536 3.08082L21.1461 4.50727L4.15783 26.609L10.6332 5.72927ZM0.546532 38.218L4.15783 26.71L22.1016 5.21932L26.8791 9.29421L0.970382 41.1719L27.7293 10.0063L32.2961 13.9778L7.44818 44.8379C3.30768 46.0622 -0.622118 42.2929 0.546532 38.218ZM45.0361 35.9784L7.97983 44.8379C7.76668 44.9389 7.66133 44.9389 7.44818 44.9389L33.0384 14.8942L37.7106 18.9691L19.8721 41.5785L38.5607 19.6812L46.631 26.8111C49.816 29.5606 49.179 34.552 45.0361 35.9784Z",
    fill: "#EB7500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMwStudioIcon);
export default __webpack_public_path__ + "static/media/mw-studio-icon.d1b8db7d32131b4261182702d03bd000.svg";
export { ForwardRef as ReactComponent };